/* global bocAmchart */

/**
 * Decode the data if it's encoded for cases when it comes from the uploads or when webmart implements encoding
 *
 * @param {object} data Json data
 * @param {object} chart object
 * @return {object} decoded data
 */
bocAmchart.decodeData = function(data, chart) {
    var modData = false;
    if (data.length === 1 && data[0].hasOwnProperty('data')) {
        modData =  decodeURIComponent(escape(atob(data[0].data)));
    } else if (data.hasOwnProperty('data')) {
        modData =  decodeURIComponent(escape(atob(data.data)));
    }

    if (modData) {
        data = JSON.parse(modData);
        bocAmchart.deleteExportMenu(chart);
    }

    return data;
};

/**
 * Set the the list of series and labels from the shortcode and add all the graphs to the chart
 * Also sets the valet_url based on the series list
 *
 * @param {array} fromShortcode Array of parameters taken from the shortcode
 * @param {AMConfig} chartSettings Object The settings to be used to build this chart
 * @param {array} series Array of series to be added
 * @return {void}
 */
bocAmchart.setValetDataLoader = function (fromShortcode, chartSettings, series) {
    var url, params;
    var hasMoreData = true;
    var i = 0;

    if (bocAmchart.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            chartSettings.bocSettings.id,
            "Before setValetDataLoader:",
            bocAmchart.debugClone(chartSettings),
            fromShortcode,
            series
        );
    }

    if ((typeof series === 'undefined' || (Array.isArray(series) && !series.length))
        && fromShortcode.hasOwnProperty('datasource')) {
        var homeUrl;
        if (window.hasOwnProperty("bocVars")) {
            homeUrl = window.bocVars.homeUrl;
        } else {
            homeUrl = window.CFCT.url;
        }
        url = homeUrl + fromShortcode['datasource'];
        chartSettings.bocSettings.series = 'group/NOT_FOUND';
    } else {
        if (typeof series === 'undefined') {
            series = [];

            while (hasMoreData) {
                if (fromShortcode.hasOwnProperty('series' + i)) {
                    var thisSeries = fromShortcode['series' + i];
                    series.push(thisSeries);
                    i++;
                } else {
                    hasMoreData = false;
                }
            }
        }

        if (fromShortcode.hasOwnProperty('group')) {
            var group = fromShortcode['group'];
            chartSettings.bocSettings.series = 'group/' + group;
            url = window.valet_url + "observations/group/" + group + "/json";
        } else {
            chartSettings.bocSettings.series = series.join(',');
            url = window.valet_url + "observations/" + series.join(',') + "/json";
        }

        params = [
            'recent',
            'recent_weeks',
            'recent_months',
            'recent_years',
            'start_date',
            'end_date'
        ];
        var setParams = {};

        params.forEach(function (param) {
            if (fromShortcode.hasOwnProperty(param)) {
                setParams[param] = fromShortcode[param];
            }
        });

        // If there's no shortcode date related parameters defined, use post meta fields
        if (Object.keys(setParams).length === 0 && typeof window.startdate === 'string' && typeof window.enddate === 'string') {
            setParams['start_date'] = window.startdate;
            setParams['end_date'] = window.enddate;
        }

        // Check for per chart overrides of start date based on the crop parameters
        bocAmchart.initChartVars(chartSettings);
        if (typeof bocAmchart.vars[chartSettings.bocSettings.id]['startdateOverride'] === 'string') {
            setParams['start_date'] = bocAmchart.vars[chartSettings.bocSettings.id]['startdateOverride'];
        }

        var setParamsStrings = [];
        if (Object.keys(setParams).length !== 0) {
            for (var property in setParams) {
                if (setParams.hasOwnProperty(property)) {
                    setParamsStrings.push(property + '=' + setParams[property]);
                }
            }
            url += '?' + setParamsStrings.join('&');
        }
    }

    chartSettings.dataLoader = {
        "url": url,
        "format": "json",
        "postProcess": bocAmchart.postProcessValet,
        "showErrors": false
    };


    if (chartSettings.bocSettings.hasOwnProperty('postProcessor')
        && typeof chartSettings.bocSettings.postProcessor === 'function') {

        if (bocAmchart.debug(chartSettings)) {
            // eslint-disable-next-line no-console
            console.log(
                chartSettings.bocSettings.id,
                "Assigning the postProcessor from charts bocSettings"
            );
        }

        chartSettings.dataLoader.postProcess = chartSettings.bocSettings.postProcessor;
    }


    if (fromShortcode.hasOwnProperty('postprocessor')) {
        if (bocAmchart.debug(chartSettings)) {
            // eslint-disable-next-line no-console
            console.log(
                chartSettings.bocSettings.id,
                fromShortcode.hasOwnProperty('postprocessor'),
                typeof bocAmchart[fromShortcode.postprocessor],
                "Before assigning the postProcessor: bocAmchart." + fromShortcode.postprocessor
            );
        }

        if (typeof bocAmchart[fromShortcode.postprocessor] === 'function') {
            chartSettings.dataLoader.postProcess = bocAmchart[fromShortcode.postprocessor];
        } else {
            if (bocAmchart.debug(chartSettings)) {
                // eslint-disable-next-line no-console
                console.log(
                    chartSettings.bocSettings.id,
                    "Failed to assign the postProcessor: bocAmchart" + fromShortcode.postprocessor
                );
            }
        }
    }


    if (bocAmchart.debug(chartSettings)) {
        // eslint-disable-next-line no-console
        console.log(
            chartSettings.bocSettings.id,
            "After setValetDataLoader:",
            bocAmchart.debugClone(chartSettings)
        );
    }
};
